import apiHandler from "../core/apiHandler";

const salePaymentApi = apiHandler('sale-payments');
export default salePaymentApi;
